import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpModule } from '@angular/http';

import { WebService } from './web.service';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    ],
  declarations: [],
  providers: [
    WebService,
  ],
  exports: []
})
export class WebModule {}


// WEBPACK FOOTER //
// ./src/app/shared/web.module.ts